import { render, staticRenderFns } from "./UniverseRow.vue?vue&type=template&id=5bf33f40"
import script from "./UniverseRow.vue?vue&type=script&lang=ts"
export * from "./UniverseRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports